'use strict';
// @flow
interface User {
  email: string;
  password: string;
}

export default class LoginController {
  // userEmail: string = '';
  // password: string = '';
  user: User = {
    email: '',
    password: ''
  };

  hasErrors: boolean = false;
  errorMessage: string = '';
  submitted: boolean = false;

  Auth;
  $state;
  TranslationService;

  /*@ngInject*/
  constructor(Auth, $state, TranslationService) {
    this.Auth = Auth;
    this.$state = $state;
    this.TranslationService = TranslationService;
  }

  login(form) {
    this.submitted = true;

    if (!form.$valid) {
      this.hasErrors = true;
      return;
    }
    
    this.Auth.login({
      email: this.user.email,
      password: this.user.password
    })
    .then((user) => {
      // Logged in, redirect to home
      if (user.role === 'admin') {
        this.$state.go('adminSeasons');
      } else if (user.role === 'user') {
        this.$state.go('schedule');
      }
    })
    .catch(err => {
      this.hasErrors = true;
      this.errorMessage = this.translateLoginError(err.message);
    });
  }

  /** Translate the text from the parameter */
  translateLoginError(error) {
    let keyTranslation = '';

    switch (error) {
      case 'This email is not registered.':
        keyTranslation = 'login_error_email_not_registered';
        break;
      case 'This password is not correct.':
        keyTranslation = 'login_error_password_not_correct';
        break;
      default:
        keyTranslation = 'login_error';
    }

    return this.TranslationService.translate(keyTranslation);
  }

  /** Redirect to the Send Reset password page */
  goToSendResetPassword() {
    this.$state.go('sendResetPassword');
  }
}



// WEBPACK FOOTER //
// ./client/app/account/login/login.controller.ts